// This file should only contain action type constants.

export const SET_MAPPING = 'SET_MAPPING';
export const SET_LEGACY_CONFIGURATIONS = 'SET_LEGACY_CONFIGURATIONS';
export const SET_FLAGS = 'SET_FLAGS';
